<template>
  <el-dialog
    :title="$t('CargoMsg.Cargo_ConfigPagePart')"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="page-part-config">
      <!-- 设置名称 -->
      <div class="config-section">
        <div class="section-title">{{ $t('CargoMsg.Cargo_ConfigName') }}</div>
        <div class="name-inputs">
          <el-input
            v-for="lang in languageConfigs"
            v-show="currentLang === lang.code"
            :key="lang.code"
            :value="tempInputValues[lang.code] || (localConfig.languageList.find(l => l.language === lang.code) || {}).name"
            :placeholder="lang.placeholder"
            class="name-input"
            @input="val => updateLanguageName(lang.code, val)"
          />
        </div>
        <div class="lang-selector">
          <el-radio-group v-model="currentLang" size="small">
            <el-radio-button label="zh_CN">{{ getLangName('zh_CN') }}</el-radio-button>
            <el-radio-button label="en_US">{{ getLangName('en_US') }}</el-radio-button>
            <el-radio-button label="ja_JP">{{ getLangName('ja_JP') }}</el-radio-button>
            <el-radio-button label="ru_RU">{{ getLangName('ru_RU') }}</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <!-- 区域功能 -->
      <div class="config-section">
        <div class="section-title">{{ $t('CargoMsg.Cargo_PagePartFunction') }}</div>
        <div class="function-selector">
          <el-select v-model="localConfig.blockType" :placeholder="$t('CargoMsg.Cargo_PleaseSelectFunction')" @change="handleBlockTypeChange">
            <el-option v-for="item in finalPagePartTypes" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-button
            v-if="isUploadFile"
            type="success"
            size="mini"
            @click="addUploadItem"
          >+</el-button>
        </div>
      </div>

      <!-- 业务字段配置 -->
      <div v-if="isBusinessElements" class="config-section">
        <!-- 是否只读 -->
        <div class="config-item">
          <el-checkbox v-model="localConfig.businessConfig.isReadonly">
            {{ $t('CargoMsg.Cargo_ReadOnly') }}
          </el-checkbox>
        </div>
      </div>

      <!-- 收发通配置 -->
      <div v-if="isCsnInfo" class="config-section">
        <!-- 是否只读 -->
        <div class="config-item">
          <el-checkbox v-model="localConfig.csnConfig.isReadonly">
            {{ $t('CargoMsg.Cargo_ReadOnly') }}
          </el-checkbox>
        </div>
        <!-- 字段显示 -->
        <div class="config-item">
          <div class="field-display-options">
            <el-checkbox v-model="localConfig.csnConfig.needConsignee">
              {{ $t('CargoMsg.Cargo_Consignee') }}
            </el-checkbox>
            <el-checkbox v-model="localConfig.csnConfig.needShipper">
              {{ $t('CargoMsg.Cargo_Shipper') }}
            </el-checkbox>
            <el-checkbox v-model="localConfig.csnConfig.needNotify">
              {{ $t('CargoMsg.Cargo_Notify') }}
            </el-checkbox>
            <el-checkbox v-if="isCsnInfoAlsoNotify" v-model="localConfig.csnConfig.needAlsoNotify">
              {{ $t('CargoMsg.Cargo_AlsoNotify') }}
            </el-checkbox>
            <el-checkbox v-if="isCsnInfoAgentParty" v-model="localConfig.csnConfig.needAgentParty">
              {{ $t('CargoMsg.Cargo_AgentParty') }}
            </el-checkbox>
          </div>
        </div>
      </div>

      <!-- TODO: 上传文件配置，这部分暂时隐藏，待沟通一些需求细节后再使用 -->
      <!-- <div v-if="isUploadFile" class="config-section"> -->
      <div v-if="false" class="config-section">
        <el-form :model="localConfig.uploadConfig" label-width="120px">
          <div v-for="(item, index) in localConfig.uploadConfig.items" :key="index" class="upload-item">
            <div class="upload-item-header">
              <el-form-item :label="$t('CargoMsg.Cargo_OperationInstructions')">
                <el-input v-model="item.instruction" />
              </el-form-item>
              <el-button
                type="danger"
                size="mini"
                @click="removeUploadItem(index)"
              >-</el-button>
            </div>
            <el-form-item :label="$t('CargoMsg.Cargo_InstructionParameter')">
              <el-input
                v-model="item.parameter"
                type="textarea"
                :rows="3"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>

      <!-- 装箱信息配置 -->
      <div v-if="localConfig.blockType === PAGE_PART_TYPE.CONTAINER_INFO.value" class="config-section">
        <div class="config-item">
          <div class="field-display-options">
            <el-checkbox v-model="localConfig.containerConfig.isReadonly">{{ $t('CargoMsg.Cargo_ReadOnly') }}</el-checkbox>
            <el-checkbox v-model="localConfig.containerConfig.showContainerCargoInfo">{{ $t('SystemMaintenance.DisplayCargoPackingInformation') }}</el-checkbox>
          </div>
        </div>
        <div class="config-item">
          <span class="title">{{ $t('SystemMaintenance.ControlPropertyConfiguration') }}</span>
        </div>
        <div class="config-item">
          <div class="field-display-options" style="padding-left: 15px">
            <el-checkbox v-model="localConfig.containerConfig.showMasterContainerModeIfMaster" disabled>{{ $t('SystemMaintenance.WhenMainTicketDisplayMode') }}</el-checkbox>
            <el-checkbox v-model="localConfig.containerConfig.showUpdatePortDataButton">{{ $t('SystemMaintenance.UpdatePortDataButton') }}</el-checkbox>
          </div>
        </div>
      </div>

      <!-- 空运货物信息配置 -->
      <div v-if="localConfig.blockType === PAGE_PART_TYPE.AE_CARGO_INFO.value" class="config-section">
        <div class="config-item">
          <div class="field-display-options">
            <el-checkbox v-model="localConfig.aeCargoInfoConfig.isReadonly">{{ $t('CargoMsg.Cargo_ReadOnly') }}</el-checkbox>
          </div>
        </div>
        <div class="config-item">
          <span class="title">{{ $t('AirExport.ControlDisplayConfiguration') }}</span>
        </div>
        <div class="config-item">
          <div class="field-display-options" style="padding-left: 15px">
            <el-checkbox v-model="localConfig.aeCargoInfoConfig.goodsInfoContract">{{ $t('AirExport.WovenFabricorder') }}</el-checkbox>
            <el-checkbox v-model="localConfig.aeCargoInfoConfig.goodsInfoBooking">{{ $t('AirExport.BookingForCargobooking') }}</el-checkbox>
            <el-checkbox v-model="localConfig.aeCargoInfoConfig.goodsInfoActual">{{ $t('AirExport.ItemMaoTiForwardWarehouseActual') }}</el-checkbox>
            <el-checkbox v-model="localConfig.aeCargoInfoConfig.quantityStation">{{ $t('CargoMsg.Cargo_Terminal') }}</el-checkbox>
            <el-checkbox v-model="localConfig.aeCargoInfoConfig.quantitySigning">{{ $t('CargoMsg.Cargo_SignContract') }}</el-checkbox>
            <el-checkbox v-model="localConfig.aeCargoInfoConfig.goodsInfoDocument">{{ $t('AirExport.ItemMaoTiOrderProcessing') }}</el-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="handleClose">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  BUSINESS_TYPE,
  PAGE_PART_TYPE,
  DEFAULT_PAGE_PART,
  DEFAULT_BUSINESS_CONFIG,
  DEFAULT_CSN_CONFIG,
  DEFAULT_CONTAINER_CONFIG,
  APPLICATION_SCENE,
  DEFAULT_AE_CARGO_INFO_CONFIG
} from '@/class/cargo/model/parameters/AiCustomPageConstants'
import { isCsnInfoPagePartType, isCsnInfoAlsoNotifyPagePartType, isCsnInfoAgentPartyPagePartType } from '@/class/cargo/model/utils/AiCustomPageUtil'
import { getCurrentLangCode, getLangName } from '@/utils/langUtil'

export default {
  name: 'AiCustomPagePagePartConfig',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    businessType: {
      type: Number,
      default: 0
    },
    pagePart: {
      type: Object,
      required: true
    },
    isCreatePagePart: {
      type: Boolean,
      default: false
    },
    applicationScene: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      PAGE_PART_TYPE,
      currentLang: 'zh_CN',
      localConfig: DEFAULT_PAGE_PART(this.pagePart.id),
      currentElements: [],
      oldBlockType: 1,
      languageConfigs: [
        { code: 'zh_CN', placeholder: '请输入中文名称' },
        { code: 'en_US', placeholder: 'Please enter English name' },
        { code: 'ja_JP', placeholder: '日本語名を入力してください' },
        { code: 'ru_RU', placeholder: 'Введите название на русском' }
      ],
      tempInputValues: {}
    }
  },
  computed: {
    pagePartTypes() {
      // 根据应用场景过滤页签类型
      const allTypes = [
        { value: PAGE_PART_TYPE.BUSINESS_ELEMENTS.value, label: this.$t(PAGE_PART_TYPE.BUSINESS_ELEMENTS.key) },
        { value: PAGE_PART_TYPE.CSN_INFO_SE_BASIC.value, label: this.$t(PAGE_PART_TYPE.CSN_INFO_SE_BASIC.key) },
        { value: PAGE_PART_TYPE.CSN_INFO_SE_MBL.value, label: this.$t(PAGE_PART_TYPE.CSN_INFO_SE_MBL.key) },
        { value: PAGE_PART_TYPE.CSN_INFO_SE_HBL.value, label: this.$t(PAGE_PART_TYPE.CSN_INFO_SE_HBL.key) },
        { value: PAGE_PART_TYPE.CSN_INFO_SE_HBL2.value, label: this.$t(PAGE_PART_TYPE.CSN_INFO_SE_HBL2.key) },
        { value: PAGE_PART_TYPE.ACCOUNTS_RECEIVABLE.value, label: this.$t(PAGE_PART_TYPE.ACCOUNTS_RECEIVABLE.key) },
        { value: PAGE_PART_TYPE.ACCOUNTS_PAYABLE.value, label: this.$t(PAGE_PART_TYPE.ACCOUNTS_PAYABLE.key) },
        { value: PAGE_PART_TYPE.UPLOAD_FILE.value, label: this.$t(PAGE_PART_TYPE.UPLOAD_FILE.key) },
        { value: PAGE_PART_TYPE.CUSTOMS_INFO.value, label: this.$t(PAGE_PART_TYPE.CUSTOMS_INFO.key) },
        { value: PAGE_PART_TYPE.OPERATION_AREA.value, label: this.$t(PAGE_PART_TYPE.OPERATION_AREA.key) },
        { value: PAGE_PART_TYPE.CONTAINER_INFO.value, label: this.$t(PAGE_PART_TYPE.CONTAINER_INFO.key) }
      ]

      // 业务批量模式只支持：基本页签、订舱页签、MBL页签和HBL页签
      if (this.applicationScene === APPLICATION_SCENE.BUSINESS_BATCH.value) {
        return allTypes.filter(type => [
          PAGE_PART_TYPE.BUSINESS_ELEMENTS.value, // 基本页签
          PAGE_PART_TYPE.CSN_INFO_SE_BASIC.value, // 订舱页签
          PAGE_PART_TYPE.CSN_INFO_SE_MBL.value, // MBL页签
          PAGE_PART_TYPE.CSN_INFO_SE_HBL.value // HBL页签
        ].includes(type.value))
      }

      // 其他应用场景显示所有页签
      return allTypes
    },
    isUploadFile() {
      return this.localConfig.blockType === PAGE_PART_TYPE.UPLOAD_FILE.value
    },
    isBusinessElements() {
      return this.localConfig.blockType === PAGE_PART_TYPE.BUSINESS_ELEMENTS.value
    },
    finalPagePartTypes() {
      if (this.businessType === BUSINESS_TYPE.SEA_EXPORT.value) {
        return this.pagePartTypes
      } else if (this.businessType === BUSINESS_TYPE.AIR_EXPORT.value) {
        return [
          { value: PAGE_PART_TYPE.BUSINESS_ELEMENTS.value, label: this.$t(PAGE_PART_TYPE.BUSINESS_ELEMENTS.key) },
          { value: PAGE_PART_TYPE.AE_CARGO_INFO.value, label: this.$t(PAGE_PART_TYPE.AE_CARGO_INFO.key) },
          { value: PAGE_PART_TYPE.CSN_INFO_AE_BASIC.value, label: this.$t(PAGE_PART_TYPE.CSN_INFO_AE_BASIC.key) }
        ]
      }
      return [{ value: PAGE_PART_TYPE.BUSINESS_ELEMENTS.value, label: this.$t(PAGE_PART_TYPE.BUSINESS_ELEMENTS.key) }]
    },
    isCsnInfo() {
      return isCsnInfoPagePartType(this.localConfig.blockType)
    },
    isCsnInfoAlsoNotify() {
      return isCsnInfoAlsoNotifyPagePartType(this.localConfig.blockType)
    },
    isCsnInfoAgentParty() {
      return isCsnInfoAgentPartyPagePartType(this.localConfig.blockType)
    }
  },
  watch: {
    applicationScene(newVal, oldVal) {
      console.log('[调试] applicationScene变化:', { oldVal, newVal, pagePartTypes: this.pagePartTypes })
    }
  },
  created() {
    this.currentLang = getCurrentLangCode()
    this.initConfig()
  },
  mounted() {
    console.log('[调试] 页面分块配置 - 组件挂载:', { visible: this.visible, pagePart: this.pagePart })
  },
  methods: {
    getLangName(code) {
      return getLangName(code)
    },
    updateLanguageName(language, value) {
      const langItem = this.localConfig.languageList.find(l => l.language === language)
      if (langItem) {
        langItem.name = value
      }
    },
    initConfig() {
      // 使用默认配置作为基础
      console.log('[调试] 页面分块配置初始化 - 原始数据:', this.pagePart)
      this.localConfig = {
        containerConfig: { ...DEFAULT_CONTAINER_CONFIG() },
        aeCargoInfoConfig: { ...DEFAULT_AE_CARGO_INFO_CONFIG() },
        ...this.pagePart
      }
      // 备份原始elements
      this.currentElements = [...(this.pagePart.elements || [])]
      this.oldBlockType = this.pagePart.blockType
      // 初始化uploadConfig
      if (!this.localConfig.uploadConfig) {
        this.localConfig.uploadConfig = {
          items: []
        }
      }
      // 如果分块类型是收发通类型且csnConfig为空，则初始化
      if (this.isBusinessElements && !this.localConfig.businessConfig) {
        this.localConfig.businessConfig = { ...DEFAULT_BUSINESS_CONFIG() }
        console.log('[调试] 初始化业务字段配置:', this.localConfig.businessConfig)
      } else if (this.isCsnInfo && !this.localConfig.csnConfig) {
        this.localConfig.csnConfig = { ...DEFAULT_CSN_CONFIG() }
        console.log('[调试] 初始化收发通配置:', this.localConfig.csnConfig)
      }
    },
    addUploadItem() {
      this.localConfig.uploadConfig.items.push({
        instruction: '',
        parameter: ''
      })
    },
    removeUploadItem(index) {
      this.localConfig.uploadConfig.items.splice(index, 1)
    },
    handleClose() {
      this.$emit('update:visible', false)
      // 当新增分块但是点击取消时，应该删除临时新增的分块
      if (this.isCreatePagePart) {
        this.$emit('remove-page-part', this.pagePart, this.isCreatePagePart)
      }
    },
    handleConfirm() {
      // 默认将name字段设置为中文名称
      const chineseLang = this.localConfig.languageList.find(l => l.language === 'zh_CN')
      this.localConfig.name = chineseLang?.name || ''

      console.log('[调试] 页面分块配置确认 - 提交值:', this.localConfig)
      this.$emit('confirm', this.localConfig)
      this.$emit('update:visible', false)
    },
    async handleBlockTypeChange(newType) {
      // 如果类型没有改变，直接返回
      if (newType === this.oldBlockType) {
        console.log('[调试] 区域功能未改变，直接返回')
        return
      }

      // 显示确认对话框
      try {
        // 在创建分块时，修改分块类型无需确认对话框
        if (!this.isCreatePagePart) {
          await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmChangeBlockType'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('common.btn.confirm'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          })
        }
        this.oldBlockType = this.localConfig.blockType
        this.localConfig.blockType = newType

        // 如果是从其他类型改回原始类型
        if (newType === this.pagePart.blockType) {
          this.localConfig.elements = [...this.currentElements]
        } else {
          this.localConfig.elements = []
        }

        // 如果分块类型是收发通类型且csnConfig为空，则初始化它
        if (isCsnInfoPagePartType(newType) && !this.localConfig.csnConfig) {
          this.localConfig.csnConfig = { ...DEFAULT_CSN_CONFIG() }
          console.log('[调试] 切换分块类型时初始化收发通配置:', this.localConfig.csnConfig)
        }
      } catch (error) {
        console.log('[调试] 用户取消变更，无变化')
        this.localConfig.blockType = this.oldBlockType
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-part-config {
  .config-section {
    margin-bottom: 20px;

    .section-title {
      font-weight: bold;
      margin-bottom: 10px;
    }

    .name-inputs {
      display: inline-block;
      width: 300px;
      margin-right: 10px;
    }

    .lang-selector {
      display: inline-block;
      vertical-align: top;
    }

    .function-selector {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .el-select {
        width: 300px;
      }

      .el-button[type="success"] {
        font-weight: bold;
        font-size: 24px;
        padding: 0;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        flex: none;
        line-height: 1;
      }
    }

    .upload-item {
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      padding: 15px;
      margin-bottom: 15px;

      .upload-item-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: nowrap;

        .el-form-item {
          width: 400px;
          margin-bottom: 15px;
          flex: none;
        }

        .el-button[type="danger"] {
          font-weight: bold;
          font-size: 24px;
          padding: 0;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          flex: none;
          line-height: 1;
        }
      }
    }

    .config-item {
      margin-bottom: 15px;

      .field-display-title {
        font-weight: bold;
        margin-bottom: 10px;
        color: #606266;
      }

      .field-display-options {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        .el-checkbox {
          margin-right: 0;
        }
      }
    }

    .title {
      display: inline-block;
      position: relative;
      font-size: 13px;
      padding-left: 15px;
      line-height: 14px;
      margin-bottom: 10px;
    }

    .title::before {
      content: "";
      position: absolute;
      width: 4px;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #1f75d5;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
